import { z } from 'zod';
/**
 * Offset pagination envelope. Contract-level decisions (handoff §5 Atom B):
 * - the payload key is ALWAYS `items` — never `data`;
 * - `total` is the full filtered row count, `hasNext` is derived server-side.
 */
export const OffsetPaginationParamsSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
/** Sort params factory — pass a list of allowed sortable fields per endpoint. */
export function createSortParamsSchema(fields) {
    return z.object({
        sortBy: z.enum(fields).optional(),
        sortOrder: z.enum(['asc', 'desc']).default('asc'),
    });
}
export function createOffsetPaginatedSchema(itemSchema) {
    return z.object({
        items: z.array(itemSchema),
        total: z.number().int().min(0),
        page: z.number().int().min(1),
        limit: z.number().int().min(1),
        hasNext: z.boolean(),
    });
}
/** Build a pagination envelope; `hasNext` is derived, never trusted from input. */
export function toOffsetPaginated(items, total, params) {
    return {
        items,
        total,
        page: params.page,
        limit: params.limit,
        hasNext: params.page * params.limit < total,
    };
}
/** Translate pagination params into SQL OFFSET/LIMIT. */
export function paginationToOffsetLimit(params) {
    return { offset: (params.page - 1) * params.limit, limit: params.limit };
}
//# sourceMappingURL=offset-pagination.js.map